if (!customElements.get('wm-showcase-clips')) customElements.define('wm-showcase-clips', class extends HTMLElement {
  connectedCallback() {
    this.videos = [...this.querySelectorAll('video')];
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.button = this.querySelector('[data-motion]');
    this.controller = new AbortController();
    this.button.addEventListener('click', () => {
      this.paused = !this.paused;
      this.update();
    }, {signal:this.controller.signal});
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); });
      this.update();
    }, {threshold:0.15});
    this.videos.forEach(video => this.observer.observe(video));
    this.update();
    document.addEventListener('visibilitychange', () => this.update(), {signal:this.controller.signal});
    this.motion.addEventListener('change', event => {
      this.paused = event.matches;
      this.update();
    }, {signal:this.controller.signal});
  }
  update() {
    this.button.setAttribute('aria-pressed', String(this.paused));
    this.button.textContent = this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
    this.videos.forEach(video => {
      if (this.paused || document.hidden || video.dataset.visible !== 'true') { video.pause(); return; }
      const source = video.querySelector('source[data-src]');
      if (source) { source.src = source.dataset.src; delete source.dataset.src; video.load(); }
      video.muted = true;
      video.play().catch(() => {});
    });
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.videos?.forEach(video => video.pause()); }
});
